export default "__VITE_ASSET__DIfJFDCM__"